import * as React from 'react';

import { useAppStore } from '@40seas/frontend/dashboard/contexts';
import { useDashboardToken } from '@40seas/frontend/dashboard/hooks';
import { useIsAdmin } from '@40seas/frontend/dashboard/providers';
import { useExecute, useUser } from '@40seas/frontend/libs/hooks';
import { useMemo } from 'react';
import { LayoutStrategyManager } from '../../providers/modal/layoutStrategyManager';
import { useCreateDashboardModal } from './modal/intents/hooks/openModal/useCreateDashboardModal';

export const LayoutStrategy = ({ children }: { children: React.ReactNode }): React.ReactNode => {
    const user = useUser();
    const appStore = useAppStore();
    const isAdmin = useIsAdmin();
    const openIntentModal = useCreateDashboardModal();

    const { guestToken, urlToken } = useDashboardToken();

    const strategy = useMemo(
        () => new LayoutStrategyManager({ guestToken, urlToken, user, appStore, isAdmin }).getStrategy(),
        [user, isAdmin, appStore, guestToken, urlToken],
    );

    useExecute(
        () => strategy.openModal && openIntentModal(strategy.openModal()),
        () => !!strategy.openModal,
    );

    if (strategy.showLayout) {
        return strategy.showLayout({ children });
    }

    return children;
};
